import '@outdoorsyco/bonfire/dist/tokens/themes/theme-auto.css';

import { useEffect } from 'react';

export const AutoTheme = () => {
  useEffect(() => {
    document.body.classList.add('bf-theme-auto');
    return () => document.body.classList.remove('bf-theme-auto');
  }, []);

  return null;
};
